<template>
  <i @click.stop="toggleSquare" :class="'fa ' + fasquare"></i>
</template>

<script>
export default {
  name: 'filter-checksquare',
  data () {
    return {
      checkVal: this.value
    }
  },
  watch: {
    value () {
      this.checkVal = this.value
    }
  },
  computed: {
    fasquare () {
      if (this.checkVal) {
        return 'fa-check-square fa-lg'
      } else {
        return 'fa-square-o fa-lg'
      }
    }
  },
  props: ['value'],
  methods: {
    toggleSquare () {
      this.checkVal = !this.checkVal
      this.$emit('input', this.checkVal)
    }
  }
}
</script>


// WEBPACK FOOTER //
// filterChecksquare.vue?340546ce